import { strings } from "../../../localization";
import { Grid, GridItem, IconTimeLight, skinVars } from "@telefonica/mistica";
import React from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useAnalytics } from "../../../hooks/useAnalytics";

export const UnavailableRealTime: React.FC = () => {
	const errorInfo = strings.components.connectionFeedback.errors;

	const { updatePageView } = useAnalytics();

	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money FGTS Simulador Quente Conectando Conta",
			pagePath: "/fgts/simulador-quente/conectando",
		});
	}, []);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconTimeLight size={64} color={skinVars.colors.brand} />}
						title={errorInfo.unavailableRealTime.title}
						description={errorInfo.unavailableRealTime.text}
					/>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
};

export default UnavailableRealTime;
